import React from 'react';

const SSOContext = React.createContext({});

export default SSOContext;
